function mapValidationItems(form, bucket = {}) {
  const fields = Array.isArray(form?.fields) ? form.fields : [];
  const labelsByKey = new Map(
    fields.map((field) => [field?.key, field?.label || field?.key || 'Field'])
  );

  return Object.entries(bucket)
    .filter(([key]) => Boolean(key))
    .map(([key, message]) => ({
      key,
      label: labelsByKey.get(key) || key,
      message: String(message || 'Please review this field.'),
    }));
}

export function buildValidationSummary(form, validation) {
  return {
    errors: mapValidationItems(form, validation?.errors || {}),
    warnings: mapValidationItems(form, validation?.warnings || {}),
  };
}
